import _ from 'lodash';

import { EmbedsApiServiceConfig } from './interfaces';
import { ApiMeta, ApiService } from 'ui-common';

export class EmbedsApiService extends ApiService {
  static apiMeta: ApiMeta = {
    aiPrediction: {
      methods: [
        {
          uri: `/query/csearch-rag/{modelId}`,
          name: 'getRagPrediction',
          verb: 'POST',
        }
      ]
    },

    query: {
      methods: [
        {
          uri: `/query/search`,
          name: 'search',
          verb: 'POST',
        }, {
          uri: `/query/searchahead`,
          name: 'searchahead',
          verb: 'POST',
        }, {
          uri: `/query/browse`,
          name: 'browse',
          verb: 'POST',
        }, {
          uri: `/query/detail`,
          name: 'detail',
          verb: 'POST',
        }, {
          uri: `/query/metatags`,
          name: 'metatags',
          verb: 'POST',
        },
        {
          uri: `/query/relatedContent`,
          name: 'relatedContent',
          verb: 'POST',
        }, {
          uri: `/query/discoverFields`,
          name: 'discoverFields',
          verb: 'POST',
        }
      ]
    },

    signals: {
      methods: [
        {
          uri: `/signals`,
          name: 'signals',
          verb: 'POST',
        }
      ]
    },

    retailSignal: {
      methods: [
        {
          uri: `/retail/signals/query`,
          name: 'retailQuerySignal',
          verb: 'POST',
        },

        {
          uri: `/retail/signals/click`,
          name: 'retailClickSignal',
          verb: 'POST',
        },

        {
          uri: `/retail/signals/cartadd`,
          name: 'retailCartAddSignal',
          verb: 'POST',
        },

        {
          uri: `/retail/signals/purchase`,
          name: 'retailPurchaseSignal',
          verb: 'POST',
        },

        {
          uri: `/retail/signals/visit`,
          name: 'retailVisitSignal',
          verb: 'POST',
        },
      ]
    },

    template: {
      methods: [
        {
          uri: "/templates",
          name: "getTemplates",
          verb: "GET"
        },
        {
          uri: "/templates/{id}",
          name: "getTemplate",
          verb: "GET"
        },
        {
          uri: "/templates",
          name: "addTemplate",
          verb: "POST"
        },
        {
          uri: "/templates/{id}",
          name: "deleteTemplate",
          verb: "DELETE"
        },
        {
          uri: "/templates/{id}/render",
          name: "query",
          verb: "POST"
        },
        {
          uri: "/templates/search/{id}/render",
          name: "typeahead",
          verb: "POST"
        },
      ]
    },
  };

  constructor(config: EmbedsApiServiceConfig) {
    super(_.merge({
      apiMeta: config.apiMeta || EmbedsApiService.apiMeta,
      getServiceHost: () => config.apiUrl,
      apiPath: '',
  
      requestProps: {
        credentials: 'same-origin',
  
        headers: {
          ...((config.getRequestHeaders && config.getRequestHeaders()) || {}),
          ...(config.embedToken ? { authorization: `Embed ${config.embedToken}` } : {}),
        },
      },
    }, config));

  }

  /**
   * Do this in-place to get the prediction for now. Will move it to a dedicated service.
   * @returns 
   */
  getPredictions(query: string, modelId?: string) {
    return this.invoke.call(this, 'aiPrediction', 'getRagPrediction', {
      pathParams: { modelId: modelId || 'llama-3-8b-instruct' },

      data: { batch: [{
        text: query,
      }]},
    });
  }
}